import { Add, SaveAlt, Search, Tune } from '@mui/icons-material';
import { Autocomplete, Avatar, Chip, FormControl, IconButton, InputAdornment, Menu, MenuItem, OutlinedInput, Paper, TextField } from '@mui/material';
import CancelIcon from "@mui/icons-material/Cancel";

import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import cameraIcon from "../../assets/svg/CameraIcon.svg";
import axios from 'axios';
import { newHost } from './../Categories/CategoryProfile';
import { VEHICLES_LIST } from './../../URLs/Apis';
import { newImageUrl } from '../Manufacturers/ManufactureProfile';
import defaultImg from '../../assets/svg/defultImage.svg'
import "./Staff.css";
import { toast } from 'react-toastify';
import DeleteModal from '../../components/Modals/DeleteModal';
const Expenses = () => {
  const { user } = useSelector((state) => state.auth);
    const token = "Bearer " + user?.token;
    const [showReviewDetails, setShowReviewDetails] = useState(false)
    const [expenseDetails, setExpenseDetails] = useState(null)
    const [updateStatus, setUpdateStatus] = useState({
      status:null,
      notes:null
    })
    const [statusId, setStatusId] = useState(null)
   const handleReviewDetailsModalShow = (item) => {

  setShowReviewDetails(true);
  setExpenseDetails(item);
     if(item){
  const firstActiveImage = item?.images?.length > 0 ? item?.images[0] : null
    setActiveImage(firstActiveImage)
    }
    setStatusId(item.id)
  

  const selectedStatus = expensesStatuses.find(
    (e) => e.value == item.status
  );

  setUpdateStatus({
    status: selectedStatus
      ? {
          label: selectedStatus.key,
          id: selectedStatus.value,
          icon: selectedStatus.icon,
        }
      : null,
    notes: null,
  });
};

     const handleReviewDetailsModalClose = () =>{
                setShowReviewDetails(false)
                setUpdateStatus({
                  status:null,
                  notes:""
                })
            }
    const [submitChangeStatus, setSubmitChangeStatus] = useState('')
 

    const [activeImage, setActiveImage] = useState(null);
const handleDownload = () => {
  if (!activeImage?.full_image_url) return;

  const link = document.createElement("a");
  link.href = activeImage.full_image_url;
  link.setAttribute("download", "");
  link.setAttribute("target", "_blank"); 
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  
  
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filteredExpenses, setFilteredExpenses] = useState([]);
  
   const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

         const columns = [
            {
              field: "id",
              headerName: "Expense ID",
              flex: 1,
              minWidth: 120,
              renderCell: (params) => (
                <strong>{`#Exp- ${params.row.id}`}</strong>
              ),
            },
            {
              field: "created_by",
              headerName: "Creator Name",
              flex: 1,
              minWidth: 120,
              renderCell: (params) => (
                <div className="d-flex gap-2 align-items-center justify-content-center">
                  <img
                    src={
                      params.row?.created_by?.profile_photo_path
                        ? `${newImageUrl}${params.row?.created_by?.profile_photo_path}`
                        : defaultImg
                    }
                    width={30}
                    height={30}
                    style={{ borderRadius: "50%" }}
                  />
                  <span>{params.row?.created_by?.name}</span>
                </div>
              ),
            },
            {
              field: "stuff",
              headerName: "Technical Name",
              flex: 1,
              minWidth: 120,
              renderCell: (params) => {
                return(
                  params.row.stuff? <> <div className="d-flex gap-2 align-items-center justify-content-center">
                  <img
                    src={
                      params.row?.stuff?.profile_photo_path
                        ? `${newImageUrl}${params.row?.stuff?.profile_photo_path}`
                        : defaultImg
                    }
                    width={30}
                    height={30}
                    style={{ borderRadius: "50%" }}
                  />
                  <span>{params.row?.stuff?.name}</span>
                </div></> : <>
                <div className="">-</div>
                </>
                )
              }
            },
            {
              field: "expense_type",
              headerName: "Expense Type",
              flex: 0.8,
              minWidth: 120,
        
            },
            {
              field: "amount",
              headerName: "Amount",
              flex: 0.8,
              minWidth: 120,
              renderCell: (params) =>
                <div className='fw-bold'>{`${params.row.amount} EGP`}</div>
            },
            {
              field: "created_at",
              headerName: "Date",
              flex: 1,
              minWidth: 120,
              renderCell: (params) =>
                <div className="">{`${new Date(params.row.created_at).toLocaleDateString()} ${new Date(params.row.created_at).toLocaleTimeString()}`}</div>
            },
       
            {
              field: "status_details",
              headerName: "Status",
              flex: 0.9,
              minWidth: 120,
              renderCell: (params) => (
                <div className="d-flex gap-2 align-items-center justify-content-center">
                  <img
                    src={
                      params.row?.status_details?.icon
                        
                    }
                    width={20}
                  />
                  <span>{params.row?.status_details?.key.toLowerCase()}</span>
                </div>
              ),
            },
            {
              field: "actions",
              headerName: "Actions",
              flex: 0.9,
              minWidth: 120,
              sortable: false,
              renderCell: (params) => (
                <>
                
                <div className=''>
      <IconButton size='small' onClick={(e)=> {
        handleReviewDetailsModalShow(params.row)
        e.stopPropagation()
      }}>
                              <RemoveRedEyeOutlinedIcon/>
                            </IconButton>
                <IconButton
                  disableRipple
                  size="small"
                  onClick={(e)=>
                  { e.stopPropagation()
                    handleDeleteShow(params.row?.id)}
                  }
              
                >
                  <DeleteOutlineOutlinedIcon color='error' fontSize="small" />
                </IconButton>
                </div>
          
              
                
                </>
              )
            },
          ];
            const [paginationModel, setPaginationModel] = useState({
                  page: 0,
                  pageSize: 10,
                });
     const [show, setShow] = useState(false);
     const handleShow = () => setShow(true);
     const [imagePreviews, setImagePreviews] = useState([]);

   


         const {
           register,
           handleSubmit,
           setValue,
           control,
           reset,
           getValues
         } =useForm({
          defaultValues:{
            stuff_id: null,
            shift_id: null,
            order_id: null,
            notes: null,
            images: [],
            expense_type: null

          }
         });  
         const FileChange = (e) => {
            const files = Array.from(e.target.files);
            if (!files.length) return;

            const newPreviews = [];
            const currentFiles = getValues("images") || [];

            files.forEach((file) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                newPreviews.push(reader.result);

                if (newPreviews.length === files.length) {
                  setImagePreviews((prev) => [...prev, ...newPreviews]);
                  setValue("images", [...currentFiles, ...files]);
                }
              };
              reader.readAsDataURL(file);
            });
};


       const handleClose = () => {
        reset();
        setShow(false);
        setImagePreviews([])
      };
    const [vehicles, setVehicles] = useState([])
    const getVehicles = async ()=>{
      try {
        const response = await axios.get(`${VEHICLES_LIST}`, {
          headers: {Authorization:`${token}`}
        })
        setVehicles(response.data.data.door_step_vehicles)
      } catch (error) {
        console.log(error);
        
      }
    }
   useEffect(()=>{
   getVehicles()
   },[])   
    const [staff, setStaff] = useState([])
    const [staffShift, setStaffShift] = useState([])
    const [staffOrders, setStaffOrders] = useState([])
    const getStaff = async ()=>{
      try {
        const response = await axios.get(`${newHost}portal/stuffs`, {
          headers: {Authorization:`${token}`}
        })
        setStaff(response.data.data.stuffs)
      } catch (error) {
        console.log(error);
        
      }
    }
   const staffChange = async (item)=>{
       try {
        const response = await axios.get(`${newHost}portal/get-shifts-with-orders?stuff_id=${item.id}`, {
          headers: {Authorization:`${token}`}
        })
        setStaffOrders(response.data.data.orders)
        setStaffShift(response.data.data.shifts)
      } catch (error) {
        console.log(error);
        
      }
   }
   useEffect(()=>{
   getVehicles()
   getStaff()
   },[])  
   
   const handleUpdateStatus = async ()=>{
    const formData = new FormData()
      if(updateStatus.notes){
        formData.append("reject_reason", updateStatus.notes)

      }
      formData.append("status", updateStatus.status?.id)
       try {
        const response = await axios.post(`${newHost}portal/stuff_expenses/${statusId}/update`,
          formData
        , {
          headers: {Authorization:`${token}`}
        })
        toast.success(response.data.data.message)
        handleReviewDetailsModalClose()
        getExpenses()
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message)
      }
   }
   const submitExpenses =  async (data)=>{
   console.log(data)
     const formData = new FormData();
    data.images.length > 0 &&    data.images.forEach((file, index) => {
    formData.append(`images[]`, file);
  });

      formData.append("van_id", data.van_id)
      if(data.stuff_id){
       formData.append("stuff_id", data.stuff_id)
      }
      if(data.shift_id){
       formData.append("shift_id", data.shift_id)
      }
      if(data.order_id){
       formData.append("order_id", data.order_id)
      }

    
      formData.append("notes", data.notes)
      formData.append("expense_type", data.expense_type)

      formData.append("amount", data.amount)
      try {
        const response = await axios.post(`${newHost}portal/stuff_expenses/add_expense`,
          formData
        ,{
          headers:{Authorization:`${token}`}
        })
        toast.success(response.data.message)
        getExpenses()
        handleClose()

      } catch (error) {
        toast.error(error.response.data.message)
      }
        
   }

   const removeImage = (index) => {
  setImagePreviews((prev) => prev.filter((_, i) => i !== index));

  const currentFiles = getValues("images") || [];
  const updatedFiles = currentFiles.filter((_, i) => i !== index);

  setValue("images", updatedFiles);
};
      const [expenses, setExpenses] = useState([])   
      const [expensesStatuses, setExpensesStatuses] = useState([])   
   const getExpenses = async ()=>{
      try {
        const response = await axios.get(`${newHost}portal/stuff_expenses/fetch`, {
          headers: {Authorization:`${token}`}
        })
        setExpenses(response.data.data.expenses)
      } catch (error) {
        console.log(error);
        
      }
    }
  const getExpensesStatuses = async ()=>{
      try {
        const response = await axios.get(`${newHost}portal/expense_statuses`, {
          headers: {Authorization:`${token}`}
        })
        setExpensesStatuses(response.data.data.expense_statuses)
      } catch (error) {
        console.log(error);
        
      }
    }
   
useEffect(() => {
getExpenses()
getExpensesStatuses()
}, [])

  useEffect(() => {
    let data = [...expenses];


  if(submitChangeStatus){
    const filteredStatus = submitChangeStatus.toLowerCase()
    data = data.filter((item)=> item.status_details?.key?.toLowerCase().includes(filteredStatus) )
  }
    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.created_at)
          .toISOString()
          .split("T")[0];
        return itemDate == filterDate;
      });
    }

    if (searchQuery.trim() !== "") {
      const search = searchQuery.toLowerCase();
      data = data.filter(
        (item) =>
          item.id.toString().includes(search) ||
          item.stuff?.name
            ?.toLowerCase()
            .includes(search) || item.expense_type?.toLowerCase().includes(search)
      );
    }

    setFilteredExpenses(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, 
  [expenses, searchQuery, filterDate, submitChangeStatus]);



  const [expenseId, setExpenseId] = useState(null)
  const [showDelete, setShowDelete] = useState(false)

  const handleDeleteShow = (id)=>{
    setExpenseId(id)
    setShowDelete(true)
  }  
  const handleDeleteClose = ()=>{
    setShowDelete(false)
  }

  const deleteExpense = async ()=>{
      try {
        const response = await axios.delete(`${newHost}portal/stuff_expenses/${expenseId}/delete`, {
          headers: {Authorization:`${token}`}
        })
        toast.success(response.data.message)
        handleDeleteClose()
        getExpenses()
      } catch (error) {
        toast.error(error.response.data.message)
        
      }
  }
  return (
    <>

    {/* delete Expense */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={`Are you sure you want to delete Exp-${expenseId}? Confirm to proceed or cancel to keep them.`}
        deleteFunction={deleteExpense}
      /> 

      {/* add Expenses */}
        <Modal show={show} onHide={handleClose} dialogClassName="">
          <Modal.Header className="">
            <Modal.Title className="">Add Expense</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="my-3">
              <form onSubmit={handleSubmit(submitExpenses)}>
    
 
    
                <div className="row my-3">
                  <div className="col-12">
                    <label htmlFor="van-id">Van ID</label>
                <Controller
                  name="van_id"
                  control={control}
                  render={({ field }) => {
                    const options = vehicles.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));
    
                    return (
                      <Autocomplete
                      className='w-100'
                        size="small"
                        options={options}
                        value={options.find(opt => opt.id == field.value) || null}
                        id='van-id'
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
    
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
    
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="m-0"
                            placeholder="Select Van"
                          />
                        )}
                      />
                    );
                  }}
    />
                  </div>
                
                </div>
                <div className="row my-3">
                    <div className="col-12">
                    <label htmlFor="technical">Technical</label>
                <Controller

                  name="stuff_id"
                  control={control}
                  render={({ field }) => {
                  
         const options = staff.map(option => ({
                        label: option.name,
                        id: option.id,
                        icon: option.profile_photo_path
                      }));
                    return (
                      
                      <Autocomplete
                      className="w-100"
                      size="small"
                      options={options}
                      value={options.find(opt => opt.id == field.value) || null}
                  onChange={(e, item) => {field.onChange(item?.id || null)
                    staffChange(item)
                  }}
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => ( <div {...props} className="p-2 d-flex gap-2 align-items-center"> <img style={{width:"30px",height:"30px"}} src={option.icon? `${newImageUrl}${option.icon}` : defaultImg} alt="" /> <h6 className="m-0">{option.label}</h6> </div>)}
                      renderInput={(params) => {
                        const selected = options.find(opt => opt.id === field.value);

                        return (
                          <TextField
                            {...params}
                            placeholder={!selected ? "Select Staff" : ""}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: selected && (
                                <Chip
                                  label={selected.label}
                                  avatar={
                                    <Avatar
                                      src={
                                        selected.icon
                                          ? `${newImageUrl}${selected.icon}`
                                          : defaultImg
                                      }
                                    />
                                  }
                                  sx={{ mr: 1 }}
                                />
                              ),
                            }}
                            inputProps={{
                              ...params.inputProps,
                              value: "",   
                            }}
                          />
                        );
                      }}
                    />


                    );
                  }}
    />
                  </div>
                
                </div>
                <div className="row my-3">
                  <div className="col-md-6 col-12">
                    <label htmlFor="shift">Shift ID</label>
                             <Controller
                  name="shift_id"
                  control={control}
                  render={({ field }) => {
                  const options = staffShift.map((shift)=>{
                    return(
                      {
                        label : String(shift.id),
                        id: shift.id
                      }
                    )
                  })
    
                    return (
                      <Autocomplete
                      className='w-100'
                        size="small"
                        options={options}
                        value={options.find(opt => opt.id == field.value) || null}
                        id='shift'
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
    
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
    
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="m-0"
                            placeholder="Select Shift ID "
                          />
                        )}
                      />
                    );
                  }}
    />
        
                  </div>
                   <div className="col-md-6 col-12">
                    <label htmlFor="order">Order ID</label>
                             <Controller
                  name="order_id"
                  control={control}
                  render={({ field }) => {
                    const options = staffOrders.map((order)=>{
                    return(
                      {
                        label : String(order.id),
                        id: order.id
                      }
                    )
                  })
    
                    return (
                      <Autocomplete
                      className='w-100'
                        size="small"
                        options={options}
                        value={options.find(opt => opt.id == field.value) || null}
                        id='order'
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
    
                        renderOption={(props, option) => (
                          <li {...props} className="p-2">
                            {option.label}
                          </li>
                        )}
    
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="m-0"
                            placeholder="Select order ID "
                          />
                        )}
                      />
                    );
                  }}
    />
        
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-12">
                    <label htmlFor="type">Type *</label>
                    <TextField {...register("expense_type", 
                      )} className="w-100 m-0" type="text" size="small" id="type" placeholder="Add invoice type"/>
                  
                  </div>
                
                </div>
            <div className="row my-3">
                <div className="col-12">
                    <label htmlFor="amount">Amount *</label>
                    <TextField  {...register("amount",
                      )} className="w-100 m-0" type="text" size="small" id="amount" placeholder="Add amount" />
                 
                  </div>
            </div>
             
                <div className="row my-3">
                  <div className="col-md-12">
                    <div className="">
                <label htmlFor="description">Description (optional)</label>
                <textarea {...register("notes")} id='description' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Add invoice description'

                />
              </div>
               
                  </div>
                
                </div>
             <div className="row my-3">
  <div className="col-12">
    <label>Expenses Images *</label>

    <div className="row my-2">
{imagePreviews.map((img, index) => (
  <div className="col-md-4 my-2" key={index}>
    <div
      className="image-wrapper position-relative"
      style={{ width: "100%", height: "120px" }}
    >
      <img
        src={img}
        className="w-100 h-100 object-fit-fill rounded"
      />

      {/* Remove icon */}
      <CancelIcon
        onClick={() => removeImage(index)}
        className="remove-icon"
      />
    </div>
  </div>
))}

      

      {/* Add Image Box */}
   <div className="col-md-4 my-2">
  <label
    htmlFor="profile_photo"
    style={{
      border: "dashed 1px #C6C6C6",
      width: "100%",
      height: "120px",
      cursor: "pointer",
    }}
    className="d-flex flex-column justify-content-center align-items-center p-2"
  >
    <img src={cameraIcon} style={{ width: "40px" }} />
    <p className="main-text-color label-size m-0">Add Image</p>

    <input
      type="file"
      id="profile_photo"
      multiple
      className="d-none"
      onChange={FileChange}
    />
  </label>
</div>



    </div>
    
  </div>
  
</div>

                    <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
                  <button className="btn btn-dark px-5">Save</button>
                  <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
                </div>
    
              </form>
            </div>
    
          </Modal.Body>
        </Modal>
        {/* review expenses details */}
    <Modal show={showReviewDetails} onHide={handleReviewDetailsModalClose} dialogClassName='custom-review-modal-size'>
                        <Modal.Header closeButton>
                            <Modal.Title className='m-0 w-100'>
                              <div className="d-flex gap-5 align-items-center  w-100">
                                <div className="">
                                   <h6 className="m-0">Details invoice # {expenseDetails?.id}</h6>
                                </div>
                               
                                 <div className="">
                       <Autocomplete
                    disablePortal
                    options={expensesStatuses.map((item) => ({
                      label: item.key,
                      id: item.value,
                      icon: item.icon,
                    }))}
                    sx={{ width: "150px" }}
                    value={updateStatus.status}
                    renderOption={(props, option) => (
                      <li {...props} className="px-3 py-2 d-flex gap-3">
                        <img src={option.icon} alt="" />
                        <div className="label-size m-0">{option.label}</div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField className="m-0" {...params} />
                    )}
                    onChange={(event, newValue) => {
                      setUpdateStatus((prev) => ({
                        ...prev,
                        status: newValue,
                      }));
                    }}
/>

                                 </div>
                              </div>
                         <h6 className="main-text-color">{new Date (expenseDetails?.created_at).toLocaleDateString()}</h6>
    
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <div className="row">
                              <div className="col-md-9 col-12">
                                <div className="row">
                                                  <div className="col-12 col-md-4">
                                                    <div className="mx-4">
                                                      <h6 style={{
                                                        fontSize: "14px"
                                                      }} className="main-text-color ">Van ID</h6>
                                                        <h6 className="my-3 fw-semibold">
                                                          Van # {expenseDetails?.van_id}
                                                        </h6>
                                                    </div>
                                                  </div>
                                                  <div className="col-12 col-md-4">
                                                    <h6 style={{
                                                      fontSize: "14px"
                                                    }} className="main-text-color ">Type</h6>
                                                    <h6 className="my-3">{expenseDetails?.expense_type}</h6>
                                                  </div>
                                                  <div className="col-12 col-md-4">
                                                    <h6 style={{
                                                      fontSize: "14px"
                                                    }} className="main-text-color ">Amount</h6>
                                                    <h6 className="my-3">{`${Number(expenseDetails?.amount)?.toLocaleString("en-US")} EGP`}</h6>
                                                  </div>
                                                  
                                                </div>
                                                <div className="row mx-2">
                                                  <div className="col-12">
                                                    <h6 style={{
                                                      fontSize: "14px"
                                                    }} className="main-text-color ">Description</h6>
                                                    <h6 className="my-3">{expenseDetails?.notes}</h6>
                                                  </div>
                                                  {activeImage &&
             <div className="position-relative ">
              <img
                src={activeImage?.full_image_url}
                alt="invoice"
                className="w-100"
                style={{ height: "", objectFit: "fill" }}
              />
    
              <button
                onClick={handleDownload}
                className="btn  position-absolute"
                style={{ bottom: "0px", left: "0px", backgroundColor:"rgba(0, 0, 0, 0.6)",color:"#FFF1F1" }}
              >
                <SaveAlt fontSize='small'/> Download
              </button>
            </div>
                                                  
                                                  }
        
                                                </div>
                              </div>
                              <div className="col-md-3">
                  {expenseDetails?.images?.length > 0 ? expenseDetails?.images?.map((img) => (
              <div
                key={img?.id}
                className={`border rounded-3 p-1 my-3 ${
                  activeImage?.id == img?.id ? "border-black border-5" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveImage(img)}
              >
                <img
                  src={img?.full_image_url}
                  alt="thumb"
                  className="w-100"
                  style={{ height: "120px", objectFit: "fill" }}
                />
              </div>
            )) : null}
                              </div>
                           </div>
                           {updateStatus.status?.id == "deducted" &&
                              <div className="my-3">
                            <label className='main-text-color' htmlFor="">Estbn Notes <span className='text-danger'>*</span></label>
                                    <textarea
                            className="w-100 my-1"
                            style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }}
                            rows={3}
                            placeholder="Add notes.."
                            onChange={(e) =>
                            setUpdateStatus({
                              ...updateStatus,
                              notes: e.target.value
                            })
                            }
                          />
                           </div>
                           }
                        
                           <div className="mt-4 ">
                             <button onClick={handleUpdateStatus} className='btn btn-dark w-100'>Save</button>
                           </div>
                        </Modal.Body>
                    </Modal>
    <div className="m-4">
           <div className="d-flex justify-content-between align-items-center ">
                          <h5 className="m-0 fw-semibold">Staff Expenses</h5>
                  <div className="">
                    <button onClick={handleShow} className='btn btn-light' > <Add /> Add Invoice</button>
                  </div>

                        </div>
                         <div className="my-3 d-flex justify-content-between align-items-center">
                
                        <div className="d-flex align-items-center gap-3" style={{ width: "70%" }}>
                          <div className="w-50">
                            <FormControl className='m-0' fullWidth variant="outlined" size="small">
                
                              <OutlinedInput
                                id="search-orders"
                                placeholder='Search for expenses ID, employee name, or date ...'
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <Search />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </div>
                          <div className="w-25 position-relative">
                            <input
                              type="date"
                              className="date-input form-control"
                              value={filterDate}
                              onChange={(e) => {
                                setFilterDate(e.target.value);
                                // setPage(0);
                              }}
                            />
                
                            {filterDate && (
                              <button
                                type="button"
                                className="btn btn-sm btn-light position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                }}
                                onClick={() => {
                                  setFilterDate("");
                                  // setPage(0);
                                }}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                
                
                        </div>
          <div className=''>  
        <div onClick={(e) => setAnchorEl(e.currentTarget)} className="btn btn-light">
          <Tune
          style={{ cursor: "pointer" }}
          
        />
        </div>
        
        <Menu
        className='my-1'
          anchorEl={anchorEl}
          open={open}
          onClose={() => 
          setAnchorEl(null)
          
          }
          PaperProps={{
            sx: {
              p: 1,      
              minWidth: 150,
              backgroundColor:"#F9F9F9" ,
              borderRadius:"10px"
              
            }
          }}
        >
          {expensesStatuses.map((item) => (
           <div className="">
             <MenuItem
              key={item.value}
              onClick={() => {
                setSubmitChangeStatus(item.value);
              }}
             
              
            >
              <div className="p-2 d-flex gap-3 align-items-center">
                <img src={item.icon} alt="" />
                <div className="label-size m-0">{item.key}</div>
              </div>
            </MenuItem>
           </div>
          ))}
        </Menu>
        
        
                  
                  </div>
                   </div>
                                     <div className="my-4">
                           <div className="data-grid-small">
                        
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={filteredExpenses}
                                columns={columns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
                  
                
                
                        </div>

    </div>
    </>

  )
}

export default Expenses